import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';

// OPERATOR #4 (2026-06-22) — SSO Web→Mi Boleta. Importamos primero el módulo de
// session-import para correrlo lo antes posible en el boot (ver llamada abajo).
import { importSessionFromHandoff } from '@/lib/sessionImport';
import { queryClient } from '@/lib/queryClient';
import { router } from '@/routes';
import { startSuperApiHeartbeat } from '@/lib/superApiHeartbeat';
import '@/i18n';
import '@/index.css';

// OPERATOR #4 (2026-06-22) — SSO Web→Mi Boleta. Si llegamos desde el Checkout
// de Web con la sesión en el fragmento (`#fcsess=...`), la importamos al
// tokenStore ANTES de renderizar para que el usuario llegue autenticado (sin
// re-login). `setSession` emite SIGNED_IN, que el listener del carrito usa para
// re-scopear su storage al usuario. Idempotente: limpia el fragmento de la URL
// tras leerlo. Ver `src/lib/sessionImport.ts`.
importSessionFromHandoff();

// Super API heartbeat: autentica Mi Boleta como cliente OAuth2 (client-credentials)
// contra api-taquilla y late peticiones para aparecer "conectado" en los admins.
// Fire-and-forget: nunca bloquea el arranque ni tira errores visibles.
startSuperApiHeartbeat();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
